


















































import { Component, Mixins, Watch } from "vue-property-decorator";
import { JoinTextItem } from "../../../../domain/document/items";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { JoinTextObjectStyleReader } from "../styleReaders";
import {
  StyledTextEditableObjectMixin,
  DataValidatableMixin,
} from "./mixins";
import { IFreeInputableObject } from "./IFreeInputableObject";

@Component({
  components: {
  },
})
export default class JoinTextObject extends Mixins(
  StyledTextEditableObjectMixin,
  DataValidatableMixin,
) implements IFreeInputableObject {
  mounted(): void {
    this.updateInputElement(this.getInputableElement());
  }

  getInputableElement(): HTMLInputElement {
    return this.isMultiLine
      ? this.$refs.textarea as HTMLInputElement
      : this.$refs.input as HTMLInputElement;
  }
  
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new JoinTextObjectStyleReader(configuration.style.document.editor.objects.joinText);
  }

  editingSource: JoinTextItem;

  get titleWithLengthDescription(): string {
    return this.appendLengthDescription(this.title, this.editingSource);
  }

  get title(): string {
    if (this.toolTip) {
      return this.toolTip;
    }
    return this.editingSource.name;
  }

  get freeInputText(): string {
    return this.editingSource.value;
  }

  set freeInputText(value: string) {
    this.writeProperty((s: JoinTextItem) => {
      if (this.shouldInputFreeSelfOrAll && this.isFreeInputable) {
        // 「全てフリー入力」でフリー入力になっている状態で手入力されたときはフリー入力にする
        s.shouldInputFree = true;
      }
      s.value = this.validateText(this.editingSource, value);
      s.adjustFontSize();
    });
  }

  get freeInputMeasureText(): string {
    this.updateTextPositionHeight();
    return this.textPositionCompositing
      ? this.textPositionMeasureText
      : this.freeInputText;
  }

  get isInputableText(): boolean {
    return this.isFreeInputable && this.shouldInputFreeSelfOrAll;
  }

  updateInputElement(value: HTMLInputElement): void {
    this.inputableElement = value;
  }

  get isMultiLine(): boolean {
    return this.editingSource.isMultiLine;
  }

  @Watch("shouldInputFreeAll")
  updatedshouldInputFreeAll(newValue: string, oldValue: string): void {
    this.writeProperty(s => s.shouldInputFreeAll = newValue);
  }

  @Watch("shouldInputFreeSelfOrAll")
  onShouldInputFreeChanged(newValue: boolean, oldValue: boolean): void {
    if (!this.isFreeInputable) { return; }
    if (!this.isFocused) { return; }
    if (!newValue) { return; }
    // IEでは、いったんマウスクリックさせるかフォーカス外さないとreadonlyの切り替えが反映されない模様
    this.$nextTick(() => {
      const element = this.getInputableElement();
      if (element == null) { return; }
      element.blur();
      element.focus();
      element.select();
    });
  }

  pasteText(value: string, isForcibly?: boolean): void {
    this.insertTextToCaretPosition(value);
    this.$nextTick(() => {
      this.adjustTextFontSize();
    });
  }

  adjustTextFontSize(): void {
    if (this.editingSource.value && this.shouldInputFreeSelfOrAll) {
      this.autoAdjustFontSize();
    }
  }

  overwriteText(value: string, isForcibly?: boolean): void {
    console.error("overwriteTextは実装されていません。");
  }
}
